export default __webpack_public_path__ + "static/media/ic-stats.8d7670d8.svg";